import { CommonService, DataSharingQuery, DataStorageEnums, Query } from 'dashboard-services';
import { globalActions } from 'primary-components';

import getApiConfig from 'api/ApiConfig';

import ExcelUtils from './ExcelUtils';

export default (() => {
  const MAX_PARAM_LENGTH = 255
  const MAX_FORMULA_LENGTH = 8_192

  const addAndValidateParam = ({ paramName, paramValue, paramsExceedingLength, withComma = true }) => {
    const paramContent = `${paramName}=${paramValue}`
    if(paramContent.length > MAX_PARAM_LENGTH) {
      const id = CommonService.generateUID()
      paramsExceedingLength.push({ name: paramName, value: paramContent.replace(/""/g, '"'), id })
      return (withComma ? ", " : "") + id
    }
    return (withComma ? ", " : "") + `"${paramContent}"`
  }

  const formulaValidator = async ({ formula, paramsExceedingLength, address, setShowTooLongFormula, setAddress }) => {
    if(formula.length > MAX_FORMULA_LENGTH) {
      setShowTooLongFormula(true)
      CommonService.copyToClipboard(formula)
    } else {
      setShowTooLongFormula(false)
      const addressLocal = await ExcelUtils.addToFormulaCell({ formula, address, paramsExceedingLength })
      if(addressLocal) {
        setAddress(addressLocal)
      }
    }
  }

  const validateProviders = ({ keys, onError }) => {
    let uniqueProviders = []
    if(keys.length > 0) {
      uniqueProviders = keys.map(key => key?.source).toUnique()
      if(uniqueProviders?.length > 1) {
        onError?.()
      }
    }
    return uniqueProviders;
  }

  const showFormulaWarning = ({ address, message }) => dispatch => {
    setTimeout(() => {
      dispatch(globalActions.getToastsStore()).warning(message, "Delete Formula", {
        withCancel: false,
        confirmText: "Delete Formula",
        confirmAction: () => {
          ExcelUtils.clearTableWithFormulaAddress(address)
        }
      })
    }, 5)   
  }

  const validateProvidersForEdit = ({ keys, address }) => async dispatch => {
    const uniqueProviders = validateProviders({ keys })
    const config = dispatch(getApiConfig()),
          getQueryBuilder = () => new Query.Builder(config)
            .withFetching(true)
            .withShouldDisplayError(false),
          { queryFn } = DataSharingQuery.QUERIES.getProducers(getQueryBuilder, {
            includeSelfProducer: true,
          })
    const providers = await queryFn({ signal: new AbortController().signal, pageParam: 0 }) 
    const defaultSource = (providers?.producers || []).find(source => source.producerId === 0)?.name
    if(uniqueProviders.length > 1) {
      dispatch(showFormulaWarning({ address, message: "Formula has been modified and cannot be restored or edited." }))
      return { shouldContinue: false };
    }
    if(uniqueProviders[0] !== undefined && providers?.producers.findIndex(provider => provider?.name === uniqueProviders[0]) === -1) {
      dispatch(showFormulaWarning({ address, message: `You don't have access to ${uniqueProviders[0]} source. Formula cannot be edited.` }))
      return { shouldContinue: false };
    }
    return { defaultSource, uniqueProviders, shouldContinue: true }
  }

  const prepColumnHeaders = ({ csvHeaders, formatType }) => {
    if(formatType === DataStorageEnums.DATA_FORMAT.NCSV) {
      return ""
    }
    return csvHeaders?.map(header => `{${Object.entries(header).filter(([, value]) => value !== undefined).map(([key, value]) => `""${key}"":""${value}""`).join(", ")}}`).join(", ")
  }

  return {
    formulaValidator,
    addAndValidateParam,
    prepColumnHeaders,
    validateProviders,
    validateProvidersForEdit
  }
})()